import { TranslateStaticLoader } from "ng2-translate";
export class CombinedTranslateLoader {
    constructor(i18nService, http, prefix, suffix) {
        this.i18nService = i18nService;
        this.http = http;
        this.localLoader = new TranslateStaticLoader(http, prefix, suffix);
    }
    getTranslation(language) {
        this.i18nService.loadServerTranslations(language);
        return this.localLoader.getTranslation(language);
    }
}
//# sourceMappingURL=combined-translate-loader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/i18n/combined-translate-loader.js
// module id = null
// module chunks = 